// ============================================================
// exposureColour - an exposure chip's colours, read from its BEARER
// (2026-10-23): green when it is good for whoever wears it, amber when
// bad (`exposureGoodForBearer`). Before, green meant "helps the
// attacker", so a Painted mark - bad news for the one wearing it -
// showed green on their own sheet.
// ============================================================

import { exposureGoodForBearer, parseExposure } from '../engine/exposures';

/** The chip colours (theme tokens): good for the bearer, or bad. An unreadable code reads as good. */
export function exposureColour(code: string): { bg: string; border: string; text: string } {
  const ex = parseExposure(code);
  const good = ex ? exposureGoodForBearer(ex) : true;
  const tone = good ? 'good' : 'bad';
  return {
    bg: `var(--exposure-${tone}-bg)`,
    border: `var(--exposure-${tone}-border)`,
    text: `var(--exposure-${tone}-text)`,
  };
}
